// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2agsx","productName":"Table_productName__ykd5W"};